(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veluxa-matching-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veluxa-matching-products')) {
    class VeluxaMatchingProducts extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-product-list]');
        this.notice = this.querySelector('[data-selection-notice]');
        this.previousButton = this.querySelector('[data-direction="previous"]');
        this.nextButton = this.querySelector('[data-direction="next"]');
        this.handleChange = this.updateSelection.bind(this);
        this.handleScroll = this.updateArrows.bind(this);
        this.handleArrowClick = this.scrollProducts.bind(this);
        this.addEventListener('change', this.handleChange);
        this.list?.addEventListener('scroll', this.handleScroll, { passive: true });
        this.previousButton?.addEventListener('click', this.handleArrowClick);
        this.nextButton?.addEventListener('click', this.handleArrowClick);
        window.__veluxaMatchingProducts = window.__veluxaMatchingProducts || [];
        window.__veluxaMatchingProducts.push(this);
        this.patchCartRequest();
        this.updateArrows();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.list?.removeEventListener('scroll', this.handleScroll);
        this.previousButton?.removeEventListener('click', this.handleArrowClick);
        this.nextButton?.removeEventListener('click', this.handleArrowClick);
        window.__veluxaMatchingProducts = (window.__veluxaMatchingProducts || []).filter((item) => item !== this);
      }

      get selectedVariantIds() {
        return Array.from(this.querySelectorAll('[data-variant-id]:checked:not(:disabled)')).map((input) => input.value);
      }

      updateSelection() {
        if (this.notice) this.notice.hidden = this.selectedVariantIds.length === 0;
      }

      updateArrows() {
        if (!this.list) return;
        const atStart = this.list.scrollLeft <= 1;
        const atEnd = this.list.scrollLeft >= this.list.scrollWidth - this.list.clientWidth - 1;
        if (this.previousButton) this.previousButton.disabled = atStart;
        if (this.nextButton) this.nextButton.disabled = atEnd;
      }

      scrollProducts(event) {
        if (!this.list) return;
        const direction = event.currentTarget.dataset.direction === 'previous' ? -1 : 1;
        this.list.scrollBy({ left: direction * Math.max(180, this.list.clientWidth * 0.72), behavior: 'smooth' });
      }

      resetSelection() {
        this.querySelectorAll('[data-variant-id]:checked').forEach((input) => {
          input.checked = false;
        });
        this.updateSelection();
      }

      patchCartRequest() {
        if (window.__veluxaMatchingProductsFetchPatched) return;
        window.__veluxaMatchingProductsFetchPatched = true;
        const originalFetch = window.fetch.bind(window);

        window.fetch = async function(resource, options = {}) {
          const url = typeof resource === 'string' ? resource : resource?.url || '';
          const isCartAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);

          if (!isCartAdd || !(options.body instanceof FormData)) {
            return originalFetch(resource, options);
          }

          const productId = String(options.body.get('product-id') || '');
          const component = (window.__veluxaMatchingProducts || []).find((item) => {
            return item.isConnected
              && String(item.dataset.productId) === productId
              && item.selectedVariantIds.length > 0;
          });

          if (!component) return originalFetch(resource, options);

          const mainVariantId = String(options.body.get('id') || '');
          if (!mainVariantId) return originalFetch(resource, options);

          const quantity = Number.parseInt(options.body.get('quantity') || '1', 10);
          const mainItem = {
            id: Number(mainVariantId),
            quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
          };
          const properties = {};

          options.body.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') properties[match[1]] = value;
          });

          if (Object.keys(properties).length > 0) mainItem.properties = properties;

          const sellingPlan = options.body.get('selling_plan');
          if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

          const selectedIds = [...new Set(component.selectedVariantIds)]
            .filter((id) => id !== mainVariantId);
          const payload = {
            items: [
              mainItem,
              ...selectedIds.map((id) => ({ id: Number(id), quantity: 1 }))
            ]
          };
          const sections = String(options.body.get('sections') || '')
            .split(',')
            .map((section) => section.trim())
            .filter(Boolean);
          const sectionsUrl = options.body.get('sections_url');

          if (sections.length > 0) payload.sections = sections;
          if (sectionsUrl) payload.sections_url = sectionsUrl;

          const headers = new Headers(options.headers || {});
          headers.set('Content-Type', 'application/json');
          headers.set('X-Requested-With', 'XMLHttpRequest');

          const response = await originalFetch(resource, {
            ...options,
            headers,
            body: JSON.stringify(payload)
          });

          if (response.ok) component.resetSelection();
          return response;
        };
      }
    }

    customElements.define('veluxa-matching-products', VeluxaMatchingProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
